export class WeatherSettings {
  automaticWeather?: boolean
  timeRange?: Array<number>

  constructor(params?: Partial<WeatherSettings>) {
    Object.assign(this, params)
  }
}
